export const m = {
 /* order */
 tijiao:"Submit",
 name:"name",
 idcard:"idCard",
 tijiaoing:"Submitting",
 finish:"finish",
 gengduo:"No more",
 xiangqing:"Details",
 yuyan:"Language",
 zy:"0",
 kuaixun:"new",

    /* tabbar */
    one:"Home", 
    tow:"optional",
    three:"CSD",
    four:"found",
    five:"self",
    /* 首页 */ 
	sy_span0:"Metori",
    sy_span1:"Metori",
    sy_span2:"Established in 2000",
    sy_span3:"source:Metori",
    sy_span4:"Position proportion",
    sy_span5:"Novice project",
    sy_span6:"buy ",
    sy_span7:"details",
    sy_span8:"day",
    sy_span9:"balance",
    sy_usdt:"USDT",
    sy_usdt_added:"USDT added income",
    sy_list1:["Recharge","Withdrawal","fund","Qualification","invite friends"],
    sy_list2:["daily check-in","level","certification","team","security","service","integral","Rili","assets","investment"],
    
    fwq : "switchServer",
    syicon1: "sign in",
    syicon2: "level",
    syicon3: "qualification",
    syicon4: "invitation",
    syicon5: "certification",
    ldj: "USDT",
    ldy: "CNY",
    hd: "PopularActivities",
    min: "min",
    day:"day",
    max: "max",
    tuijian: "PopularRecommendation",
    rishouyi: "dailyIncome",
    qitou: "CNY",
    changgui: "routine",
    shouyiguo1: "balance profit",
    shouyiguo2: "usdt profit",
    mairu: "buy",
    maichu: "sell",
    lijigoumia: "BuyNow",
    jiancang: "buy",
    jiaoyi:[
      {id:'176*****082',content:"recharge ",yingli:"13000",yuan:"cny"},
      {id:'188****463',content:"withdrawal ",yingli:"8000",yuan:"cny"},
      {id:'132****768',content:"profit",yingli:"720",yuan:"cny"}
      ],
      jiaoyi1:[
        {id:'136*****502',content:"recharge ",yingli:"126800",yuan:"cny"},
        {id:'152****699',content:"withdrawal ",yingli:"19200",yuan:"cny"},
        {id:'199****468',content:"profit",yingli:"4396",yuan:"cny"}
      ],
      jiaoyi2:[
        {id:'177*****538',content:"recharge ",yingli:"13790",yuan:"cny"},
        {id:'139****562',content:"withdrawal ",yingli:"14410",yuan:"cny"},
        {id:'166****799',content:"profit",yingli:"6510",yuan:"cny"}
      ],
      jiaoyi3:[
        {id:'136*****052',content:"recharge ",yingli:"23930",yuan:"cny"},
        {id:'177****563',content:"withdrawal ",yingli:"11330",yuan:"cny"},
        {id:'162****796',content:"profit",yingli:"673",yuan:"cny"}
      ],
      jiaoyi4:[
        {id:'153*****386',content:"recharge ",yingli:"15570",yuan:"cny"},
        {id:'168****468',content:"withdrawal ",yingli:"14660",yuan:"cny"},
        {id:'135****769',content:"profit",yingli:"3220",yuan:"cny"}
      ],
      jiaoyi5:[
        {id:'182*****062',content:"recharge ",yingli:"13000",yuan:"cny"},
        {id:'155****763',content:"withdrawal ",yingli:"1168",yuan:"cny"},
        {id:'152****760',content:"profit",yingli:"596",yuan:"cny"}
      ],
      jiaoyi6:[
        {id:'137*****388',content:"recharge ",yingli:"27800",yuan:"cny"},
        {id:'199****690',content:"withdrawal ",yingli:"31100",yuan:"cny"},
        {id:'186****762',content:"profit",yingli:"1540",yuan:"cny"}
      ],
      jiaoyi7:[
        {id:'199*****082',content:"recharge ",yingli:"37500",yuan:"cny"},
        {id:'156****468',content:"withdrawal ",yingli:"18200",yuan:"cny"},
        {id:'176****563',content:"profit",yingli:"3700",yuan:"cny"}
      ],
      jiaoyi8:[
        {id:'166*****881',content:"recharge ",yingli:"19480",yuan:"cny"},
        {id:'179****466',content:"withdrawal ",yingli:"16740",yuan:"cny"},
        {id:'186****795',content:"profit",yingli:"720",yuan:"cny"}
      ],
      jiaoyi9:[
        {id:'135*****062',content:"recharge ",yingli:"24800",yuan:"cny"},
        {id:'138****461',content:"withdrawal ",yingli:"18340",yuan:"cny"},
        {id:'156****290',content:"profit",yingli:"2320",yuan:"cny"}
      ],
      /* 个人中心 */ 
      list1:["financial","team","bank","certification","Rili","investment","integral","invitation"],
      list2:["security","wRecord","rRecord","DCR","exchange","language","transformation","paymentPwd","loginPwd","signOut"],
      list3:["income details","recharge","withdrawal"],
      xinxi:"My information",
      xiangguan:"My related",
      yue:"balance",
      shouyiguo:"IncomeFruit",
      geren:"Personal Center",
      yishiming:"certified",
      weishiming:"unauthorized",
        /* 签到页面 */ 
        qd_span01:"Once a day",
      qd_span02:"Red envelope collar",
        qd_span0:"sign in",
        qd_span1:"You get 2 yuan if you sign in today",
        qd_span2:"signRemind",
        qd_span3:"Sign in",
        qd_span4:"Sign in for 30 consecutive days and get a surprise package",
        qd_span5:"points",
        qd_span6:"Invite friends rich rewards",
        qd_span7:"invitation",
        qd_span8:"Sign in to list",
        qd_span9:"Clock in success",
          /* 自选 */ 
       zx_span0:"search",
       zx_span1:"projectName",
       zx_span2:"CNY",
       zx_span3:"Rate",
       zx_span4:"Day",
        /* 理财详情 */ 
        lc_span0:"Product details",
        lc_span1:"project schedule",
        lc_span2:"total project",
        lc_span3:"Limit shots",
        lc_span4:"Recruiting cycle",
        lc_span5:"Guarantee company",
        lc_span6:"Trading rules",
        lc_span7:"applications",
        lc_span8:"rebate",
        lc_span9:"withdrawal",
        lc_span10:"today",
        lc_span11:"tomorrow",
        lc_span12:"Within tomorrow",
        lc_span13:"common problem",
        lc_span14:"W",
        lc_span15:"D",
        lc_span16:"What are the value, interest and arrival rules of the product?",
        lc_span17:"The product can be deposited at any time and has a value and interest on the same day. After deposit, if the product is held to maturity according to the product term, the principal and interest shall be cashed according to the yield of withdrawal at maturity;",
        lc_span18:"Is there any risk in investing in Neuberger Berman financial products?",
        lc_span19:"Neuberger Berman project is supervised by China Securities Regulatory Commission and is the holder of qualified foreign institutional investors (QFII). The raised funds are entrusted by ICBC and underwritten by cooperative factoring institutions. The underwriting unit provides 100% guarantee for each position building fund and equity income on the platform, and undertakes to advance the principal and interest in full to escort the investors;",
        lc_span20:"Why open online banking to buy?",
        lc_span21:"To recharge the balance account, you need to pay to the designated account provided by us through online banking in order to buy Neuberger Berman financial products, so you need to open online banking.",
        lc_span22:"cycle",
        lc_span23:"day",
        lc_span24:"lowRisk",
        lc_span25:"taurusQuality",
        lc_span26:"netWorth",
        lc_span27:"stable",
        lc_span28:"schedule",
        lc_span29:"guarantee",
        lc_span30:"Has ended",
        /* 发现 */ 
        fx_span0:"Found",
        fx_span1:"Year-end integral",
        fx_span2:"hot",
        fx_span3:"recommend",
         /* 会员等级 */ 
         dj_span0:"Membership grade",
         dj_span1:"With reference to the following table",
         dj_span2:"level name",
         dj_span3:"limit",
         dj_span4:"rates",
         dj_span5:"integral",
          /* 邀请好友 */ 
          yq_span0:"InviteCode",
          yq_span1:"1.First level reward",
          yq_span2:"1.Secondary reward",
          yq_span3:"1.Three level reward",
          yq_span4:"Download APP",
            /* 实名认证 */ 
            sm_span01:"Your name",
            sm_span02:"Please enter your name",
            sm_span03:"Your ID",
            sm_span04:"Please enter your ID",
            sm_span05:"name",
            sm_span06:"ID",
            sm_span0:"Authentication",
            sm_span1:"Ensure the safety of funds !",
            sm_span2:"Upload photos",
            sm_span3:"Fill in information",
            sm_span4:"Complete certification",
            sm_span5:"ID card picture",
            sm_span6:"Portrait face",
            sm_span7:"National emblem surface",
            sm_span8:"Identity information",
              /* 登录 */ 
              dl_span01:"No account",
              dl_span02:"register",
              dl_span03:"New user registration",
              dl_span04:"Enter your mobile number to create an account",
              dl_span05:"Forget password",
              dl_span06:"Retrieve the password through the mobile phone number",
              dl_span07:"Change Password",
              dl_span08:"Reset the new login password",
               dl_span09:"Reset the new payment password",
              dl_span0:"Welcome to login",
              dl_span1:"Welcome to login jensen!",
              dl_span2:"phone",
              dl_span3:"password",
              dl_span4:"Code login",
              dl_span5:"Forget password",
              dl_span6:"Login",
              dl_span7:"Register",
              dl_span8:"Code",
              dl_span9:"Send code",
              dl_span10:"Automatic reading code",
              dl_span11:"Password login",
              dl_span12:"Logging in",
              dl_span13:"again ",
              dl_span14:"Invitation code ",
             dl_span15:"Agreed terms and conditions",
             dl_span16:"Register with mobile number",
             dl_span17:"Your new password settings",
             dl_span18:"Confirm password",
             dl_span19:"Original password",
             dl_span20:"New password",
             dl_span21:"Modify login password",
             dl_span22:"Modify payment password",
			 dl_span23:"Login method",
			 dl_span24:"Remember me",
              /* 交易 */ 
              jy_span01:"Protection",
               jy_span02:"total assets",
               jy_span03:"Position",
               jy_span04:"Hide not started",
               jy_span05:"Operation record",
          jy_span0:"Transaction",
          jy_span1:"total assets",
          jy_span2:"estimate",
          jy_span3:"Total revenue",
          jy_span4:"Recharge",
          jy_span5:"Withdrawal",
          jy_span6:"My holding",
          jy_span7:"amount",
          jy_span8:"rate",
          jy_span9:"profit",
		  jy_span10:"已收本息",
		  jy_span11:"待收本息",
		  jy_span12:"已收USDT",
		  jy_span13:"待收USDT",
           /* 积分商城 */ 
           jf_span01:"Points account",
           jf_span02:"Exchange details",
           jf_span03:"Preferential activities",
           jf_span04:"Good gifts keep changing",
           jf_span05:"sign in",
           jf_span0:"Integral mall",
           jf_span1:"Available points",
           jf_span2:"capital",
           jf_span3:"order",
           jf_span4:"people",
           jf_span5:"Specifications",
           jf_span6:"Quantity",
           jf_span7:"Remarks",
           jf_span8:"Enter comments",
           jf_span9:"Redeem now",
           jf_span10:"Product introduction",
                 /* 积分商城提交订单*/ 
                 jf_span11:"place order",
                 jf_span12:"consignee",
                 jf_span13:"phone",
                 jf_span14:"region",
                 jf_span15:"address",
                 jf_span16:"Commodity information",
                 jf_span17:"Payment succeeded",
                   /* 财务明细*/ 
                   cw_span1:"Financial details",
                   cw_span2:"Received",
                   cw_span3:"Uncollected",
                   cw_span4:"Financial list",
                   cw_span5:"USDT Uncollected",
                   cw_span6:"USDT collected",
                   /* 我的团队*/ 
                   td_span0:"My team",
                    /* 我的投资*/ 
                        tz_span0:"My investment",
                        tz_span1:"OrderNumber",
                        tz_span2:"time",
                        tz_span3:"Amount obtained",
                        tz_span4:"money",
                        tz_span5:"amount",
                        tz_span6:"time",
                           /* 日利宝*/ 
                           rlb_span0:"RI Libao",
                           rlb_span1:"Available amount ",
                           rlb_span2:"Total revenue",
                           rlb_span3:"10000 income",
                           rlb_span4:"Transfer out",
                           rlb_span5:"Transfer in",
                           rlb_span6:"out in detailed",
                           rlb_span7:"Total amount",
                           rlb_span8:"out amount",
                           rlb_span9:"in amount",
                           rlb_span10:"Transfer out amount",
                           rlb_span11:"Transfer in amount",
                           rlb_span12:"Confirm transfer out",
                           rlb_span13:"Confirm transfer in",
                             /* 提现、充值、兑换记录*/ 
                         jl_span0:"Withdrawal record",
                         jl_span1:"Recharge record",
                         jl_span2:"Exchange record",
                         jl_span3:"reply",
                         jl_span4:"Reviewed",
                         jl_span5:"Completed",
                         jl_span6:"Rejected",
                         jl_span7:"Ignored",
                         jl_span8:"time",
                         jl_span9:"cancel",
                         jl_span10:"no delivery",
                         jl_span11:"delivery",
                          /* 银行卡*/ 
                          yh_span01:"Bound",
                          yh_span02:"Quick payment",
                    yh_span0:"bank card",
                    yh_span1:"Cardholder name",
                    yh_span2:"Add bank",
                    yh_span3:"Add USDT",
                    yh_span4:"bank card",
                    yh_span5:"bank type",
                    yh_span6:"bank deposit",
                    yh_span7:"pay password",
                    yh_span8:"USDT address",
             /* 充值、提现*/ 
             ct_span01:"Withdrawal amount",
             ct_span02:"Withdrawal amount",
             ct_span03:"Withdrawal amount",
             ct_span04:"Full withdrawal",
             ct_span0:"Last 4 digits of card number",
             ct_span1:"next step",
             ct_span2:"Contact before recharging",
             ct_span3:"payment method",
             ct_span4:"Bank card payment",
             ct_span5:"USDT payment",
             ct_span6:"Immediate payment",
             ct_span7:"Account balance",
             ct_span8:"Withdrawal to bank",
             ct_span9:"Withdrawal to USDT",
             ct_span10:"Available balance ",
			 ct_span1c:"USDT",
             ct_span11:"Default login password",
             ct_span12:"USDT Recharge",
             ct_span13:"QR code recharge",
             ct_span14:"Wallet address",
             ct_span15:"preservation",
             ct_span16:"copy",
             ct_span17:"Bank card recharge",
             ct_span18:"USDT recharge",
             ct_span19:"Num",
             ct_span20:"Please enter quantity",
             ct_span21:"Please enter quantity",
             ct_span22:"Confirm recharge",
             ct_span23:"Maximum recharge",
             ct_span24:"recharge amount",
             /* 客服*/ 
             kf_span0:"customer service",
             /* 切换服务器*/ 
             fw_span0:"Switch server",
             fw_span1:"server",
               /* 产品认购 */ 
         rg_span0:"Product subscription",
         rg_span1:"min ",
         rg_span11:"，max ",
         rg_span12:"，count ",
         rg_span2:"，rate ",
         rg_span3:"Buying results",
         rg_span4:"checkout success",
         rg_span5:"Balance view my assets",
           /* 资产互转 */ 
           hz_span0:"transformation",
           hz_span1:"USDT",
           hz_span2:"Arrival",
           hz_span3:"Mode",
           hz_span4:"Quantity",
           hz_span5:"Please fill in the remarks",
           hz_span6:"exchange rate",
           hz_span7:"Apply for exchange",
           hz_span8:"CNY --> USDT",
           hz_span9:"USDT --> CNY",
           hz_span10:"CNY Pay",
           hz_span11:"USDT Pay",
           hz_span12:"Recharge",
           hz_span13:"Withdrawal",

           hz_span20:"Product features",
           hz_span21:"value today",
           hz_span211:"Holiday general",
           hz_span22:"at any time",
           hz_span221:"Arrive today",
           hz_span23:"bank deposit",
           hz_span231:"guarantee",
           hz_span19:"Product",
           hz_span24:"Calculation",
           hz_span25:"Mode",
           hz_span26:"Income calculation: position reversal amount 1100.00 x daily chemical interest rate 0.16% x position days 720 = equity income 1267.20",
           hz_span27:"Return on expiration of rebate: principal 1100.00 + principal 1100.00 x return on expiration 0.16% x720 days = equity return 2367.20",
           hz_span28:"Asset transfer",
           hz_span29:"language",
}